import { unmask } from '@/components/telephone/telephoneUtil';

export function nettoyageTelephone(form) {
  const pph = JSON.parse(JSON.stringify(form));
  pph.telephone = unmask(pph.telephone);
  pph.mailPrincipal =
    pph.mailPrincipal === 'Non visible' ? 'est@non.visible' : pph.mailPrincipal;
  pph.contacts.forEach(contact => {
    contact.fax = unmask(contact.fax);
    contact.telephones.forEach(telephone => {
      telephone.numero = unmask(telephone.numero);
    });
  });
  return pph;
}
